import React,{useReducer,useEffect, useState, useRef, useCallback} from 'react';
import { i18nIntl, NSchange } from '../../lib/ep';
import ActionButton from './ActionButton';
import ActionLink from './ActionLink';
import ConfirmButton from './ConfirmButton';
import Input from './Input';
import Model from './Model';
import TextArea from './TextArea';
import Select from './Select';
import Checkbox from './Checkbox';
import DynamicFields from './DynamicFields';
import { DndProvider,useDrag,useDrop } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
import { HTML5Backend } from 'react-dnd-html5-backend'
import { v4 as uuidv4 } from 'uuid';
import Range from './Range';
import RichEditor from './RichEditor';


const MouseOver = (element,onOver)=>{
	return (<span onMouseEnter={()=>onOver(true)} onMouseLeave={()=>onOver(false)}>
		{element}
	</span>);
}

const Element = (props)=> {

	const [{isDragging}, drag] = useDrag(() => ({
		type:'GALLERY',
		collect:(monitor) => ({
			isDragging:monitor.isDragging(),
		}),
		item:props.item
	}));
	return (
		<div ref={drag}>
			{props.item.type}
		</div>
	)
}

const Columns2 = (props) => {
	const item = {'type':'columns',items:[
		{id:uuidv4(),type:"col",width:'30'},
		{id:uuidv4(),type:"col",width:'30'}
	]};
	return <Element item={item} />
}

const ButtonBlock = (props) => {
	const item = {'type':'button',items:[]};
	return <Element item={item} />
}

const RowsBlock = (props) => {
	const item = {'type':'rows',items:[
		{id:uuidv4(),type:"row",height:'30'},
		{id:uuidv4(),type:"row",height:'30'}
	]};
	return <Element item={item} />
}

const ContainerBlock = (props) => {
	const item = {'type':'container',items:[]};
	return <Element item={item} />
}

const TextBlock = (props) => {
	const item = {'type':'text',items:[]};
	return <Element item={item} />
}


const BlockVisual = (props) => {
	const style = {};
	if (props.highlight == props.element.id) {
		style.border = "3px solid red";
	}

	switch(props.element.type) {
		case 'button':
			return (
				<div id={props.element.id} style={style}>
					<ActionButton>{props.element.label ? props.element.label : 'Button'}</ActionButton>
				</div>
			)
		case 'text':
			return (
				<div id={props.element.id} style={style} dangerouslySetInnerHTML={{ __html: props.element.text ? props.element.text.replace(/\n/g, '<br />'):'Text'}} />
			)
		
	}
	return null;
}

const BlockEditor = ({item,changeItem}) => {

	const directions = [{k:'v',v:'Vertical'},{k:'h',v:'Horizontal'}];
	const vAlign = [{k:'t',v:'Top'},{k:'c',v:'Center'},{k:'b',v:'Bottom'}];
	const hAlign = [{k:'l',v:'Left'},{k:'c',v:'Center'},{k:'r',v:'Right'}];

	switch(item.type) {
		case 'container':
			return (
				<div>
					<h2>Container</h2>
					<Select name="direction" values={directions} value={item.direction || 'v'} change={(k,v)=>changeItem(item.id,k,v)}>Direction</Select>
					<Select name="vAlign" values={vAlign} value={item.vAlign || 'c'} change={(k,v)=>changeItem(item.id,k,v)}>Vertical alignment</Select>
					<Select name="hAlign" values={hAlign} value={item.hAlign || 'c'} change={(k,v)=>changeItem(item.id,k,v)}>Horizontal alignment</Select>
				</div>
			)
	}

	return (
		<div>
			<h2>Info of the item</h2>
			{item.type == 'col' && (
				<Range min={0} key={`${item.id}`} max={100} change={(k,v)=>changeItem(item.id,k,v)} value={parseInt(item.width)} name="width" default={50} step={10}>Witdh</Range>
			)}

			{item.type == 'button' && (
				<Input name="label" change={(k,v)=>changeItem(item.id,k,v)} value={item.label} >Text</Input>
			)}

			{item.type == 'text' && (
				<RichEditor name="text" change={(k,v)=>changeItem(item.id,k,v)} value={item.text} />
			)}

		</div>
	)
}


const DropZone = (props) => {
	const currentPreview = useRef(false);
	const currentPos = useRef(0);
	const direction = props.element.direction == undefined ? 'column' : (props.element.direction == 'v' ? 'column':'row');

	const [layout,setLayout] = useState(props.layout);

	const [{ isOver, isOverCurrent }, drop] = useDrop (() => ({
		accept:'GALLERY',
		drop:(item, monitor) => {
			const didDrop = monitor.didDrop();
			if (didDrop) return;
			currentPreview.current = false;
			if (props.dispatch != undefined) {
				props.dispatch({type:'ADD_ELEMENT',item,target:props.element,pos:currentPos.current});
			}
		},
		hover(item, monitor) {
			let pos = currentPos.current;
			if (layout.length > 0) {
				for (var i in layout) {
					let inti = parseInt(i);
					if (layout[i].id == undefined) continue;
					if (layout[i].id == currentPreview.current) continue;

					const el = document.getElementById(layout[i].id);
					const hoverBoundingRect = el && el.getBoundingClientRect();
					const clientOffset = monitor.getClientOffset();
					const hoverClientY = direction == 'column' ? (clientOffset.y - hoverBoundingRect.top) : (clientOffset.x - hoverBoundingRect.left);

					if (hoverClientY > 0 && currentPos.current < inti) {
						pos = inti;
						continue;
					}

					if (hoverClientY < 0) {
						pos = Math.max(0,inti-1);
						if (currentPos.current >= inti) {
							pos = inti;
						}
						break;
					}
				}
			}	
			if (currentPreview.current != false && currentPos.current == pos)  return;
			currentPreview.current = item.id;
			currentPos.current = pos;
			setLayout(l=>{
				let temp = l.filter(pl=>(pl.id != undefined));
				return [
					...temp.slice(0,pos),
					item,
					...temp.slice(pos,l.length)
				];
			});
		},
		collect: (monitor) => ({
			isOver: monitor.isOver(),
			isOverCurrent: monitor.isOver({ shallow: true }),
		})
	}), [layout]);

	
	useEffect(()=>{
		if (isOverCurrent == false) {
			currentPreview.current = false;
			setLayout(props.layout);
		}
	},[isOverCurrent])

	useEffect(()=>{
		setLayout(props.layout);
	},[props.layout])


	const visual = BlockVisual({element:props.element,highlight:props.highlight});
	if (visual != null) return visual;

	const style = {backgroundColor:props.level == 1 ? 'lightblue':'coral'}

	if (props.level == 3) style.backgroundColor = 'lightgreen';

	if (isOverCurrent) style.backgroundColor = 'yellow';

	const width = props.element.width != undefined ? `${props.element.width}%`: "100%";
	const height = props.element.height != undefined ? `${props.element.height}%`: "50%";
	

	let justifyContent = 'center';
	switch(props.element.vAlign) {
		case 't': justifyContent='flex-start';break;
		case 'c': justifyContent='center';break;
		case 'b': justifyContent='flex-end';break;
	}

	let alignItems = 'center';
	switch(props.element.hAlign) {
		case 'l': alignItems='flex-start';break;
		case 'c': alignItems='center';break;
		case 'r': alignItems='flex-end';break;
	}

	if (props.highlight == props.element.id) {
		style.border = "3px solid red";
	}

	if (direction == 'row') {
		let tmp = justifyContent;
		justifyContent = alignItems;
		alignItems = tmp;
	}
	
	return (
		<div id={props.element.id} style={{
			display:"flex",
			flexDirection:direction,
			justifyContent:justifyContent,
			alignItems:alignItems,
			width,
			height,
			...style}} ref={drop}>
			{layout && layout.map(nested=>(
				<DropZone key={`dz_${nested.id}`} {...props} element={nested} layout={nested.items || []} level={props.level+1} />
			))}
			{(layout == undefined || layout.length == 0) && (
				<span>Dropzone {props.level}</span>
			)}
		</div>
	)
}


const LayoutTree = (props) => {
	const deleteElement = (id) => {
		props.dispatch({type:'DELETE_ELEMENT',id});
	}

	const selectElement = (id) => {
		props.dispatch({type:'SELECT_ELEMENT',id});
	}

	const changeItem = (id,k,v) => {
		props.dispatch({type:'CHANGE_ITEM',id,k,v})
	}

	const upOrder = (id) => {
		props.dispatch({type:'UP_ORDER',id})
	}

	const downOrder = (id) => {
		props.dispatch({type:'DOWN_ORDER',id})
	}

	const highlight = (id,status) => {
		props.dispatch({type:'HIGHLIGHT',id,status})
	}

	return (
		<div>
			{props.layout.map(item=>(
				<div key={`tree_${item.id}`} style={{marginLeft:`${15 * (props.level -1)}px`}}>

					<ActionLink onClick={()=>upOrder(item.id)}> UP </ActionLink> |
					<ActionLink onClick={()=>downOrder(item.id)}> DW </ActionLink> |

					{MouseOver(
						<ActionLink onClick={()=>selectElement(item.id)}>Item {item.type}</ActionLink>,
						(status)=>{highlight(item.id,status)})}
					{item.id != 'principal' && (
					<ActionLink onClick={()=>deleteElement(item.id)}>Delete</ActionLink>
					)}

					{item.id == props.selected_item && (
						<BlockEditor item={item} changeItem={changeItem} />
					)}

					{item.items && (
						<LayoutTree {...props} layout={item.items} level={props.level+1} />
					)}
				</div>
			))}
		</div>
	)
}

const findTree = (tree,id,operation) => {
	for (var i in tree) {
		if (tree[i].id == id ) {
			tree[i] = operation(tree[i]);
			return [...tree];
		}

		if (tree[i].items == undefined) continue;

		if (tree[i].items != undefined) {
			tree[i].items = findTree([...tree[i].items],id,operation);
		}
	}
	return [...tree];
}

const deleteTree = (tree,id) => {
	for (var i in tree) {
		if (tree[i].id != id) {

			if (tree[i].items != undefined) {
				tree[i].items = deleteTree(tree[i].items,id);
			}
		}
		else {
			return tree.filter(t=>t.id != id);
		}
	}
	return tree;
}

const orderTree = (tree,id,type) => {
	for (var i in tree) {
		if (tree[i].id != id) {

			if (tree[i].items != undefined) {
				tree[i].items = orderTree(tree[i].items,id,type);
			}
		}
		else {

			let pos = parseInt(i);

			if (type == '-' && pos > 0) {
				return [...tree.slice(0,pos-1),tree[i],tree[pos-1],...tree.slice(pos+1)];
			}

			if (type == '+' && pos < tree.length-1) {
				return [...tree.slice(0,pos),tree[pos+1],tree[i],...tree.slice(pos+2)];
			}
		}
	}
	return tree;
}

const reducer = (state,action)=>{
	switch(action.type) {
		case 'CHANGE_ITEM':

			let modified_item = findTree(state.layout,action.id,(target)=>{
				return {...target,[action.k]:action.v}
			})
			return {...state,layout:modified_item};

		case 'HIGHLIGHT':
			
			if (action.status == false) return {...state,highlight:false};

			return {...state,highlight:action.id}
		
		case 'ADD_ELEMENT':
			let item = {...action.item,id:uuidv4()}

			//if (action.target.id == 'main')  return {...state,layout:[...state.layout,item],selected_item:item.id};

			let modified_tree = findTree(state.layout,action.target.id,(target)=>{
				if (target.items == undefined) target.items = [];

				if (action.pos != undefined) return {
					...target,items:[
						...target.items.slice(0,action.pos),
						item,
						...target.items.slice(action.pos)
					]
				}

				return {...target,items:[
					...target.items,item
				]}
			})

			return {...state,layout:modified_tree,selected_item:item.id};

		case 'DELETE_ELEMENT':
			return {...state,layout:deleteTree(state.layout, action.id)}
			
		case 'SELECT_ELEMENT':
			return {...state,selected_item:state.selected_item == action.id ? false : action.id}

		case 'UP_ORDER':
			return {...state,layout:orderTree(state.layout, action.id,'-')}
		case 'DOWN_ORDER':
			return {...state,layout:orderTree(state.layout, action.id,'+')}
		
		default:
			return state;
	}
}
/*
const SortCard = (props) => {

	const index = props.index;

	const ref = useRef(null);
	const [{ handlerId }, drop] = useDrop({
		accept: "CARD",
		collect(monitor) {
			return {
				handlerId: monitor.getHandlerId(),
			};
		},
		hover(item, monitor) {
			if (!ref.current) {
				return;
			}
			const dragIndex = item.index;
			const hoverIndex = index;
			// Don't replace items with themselves
			if (dragIndex === hoverIndex) {
				return;
			}
			// Determine rectangle on screen
			const hoverBoundingRect = ref.current && ref.current.getBoundingClientRect();
			// Get vertical middle
			const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
			// Determine mouse position
			const clientOffset = monitor.getClientOffset();
			// Get pixels to the top
			const hoverClientY = clientOffset.y - hoverBoundingRect.top;
			// Only perform the move when the mouse has crossed half of the items height
			// When dragging downwards, only move when the cursor is below 50%
			// When dragging upwards, only move when the cursor is above 50%
			// Dragging downwards
			if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
				return;
			}
			// Dragging upwards
			if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
				return;
			}
			// Time to actually perform the action
			props.moveCard(dragIndex, hoverIndex);
			// Note: we're mutating the monitor item here!
			// Generally it's better to avoid mutations,
			// but it's good here for the sake of performance
			// to avoid expensive index searches.
			item.index = hoverIndex;
		},
	});
	const [{ isDragging }, drag] = useDrag({
		type: "CARD",
		item: () => {
			return { id:props.item.id, index:props.index };
		},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	});

	drag(drop(ref));
	const opacity = isDragging ? 0 : 1;

	return (
		<div ref={ref} style={{border:'1px solid black',opacity}}>
			{props.item.id}
		</div>
	)
}*/


export const BlockBuilder = ({ form, onChange, ...props }) => {
	const only = ['field', 'checkbox'];
	const skip = ['date', 'attach'];

	const [state,dispatch] = useReducer(reducer,{
		layout:[{id:'principal',type:'container',items:[]}],
		selected_item:false,
		highlight:false,
	});

	const blocks = [
		{ type:'column', icon:'knk-text', label:"Columns"},
		{ type:'rows', icon:'knk-options-list' ,label:"Rows" },
		{ type:'checkbox', icon:'knk-ok', label:"Opt-in field" },
		{ type:'date', icon:'knk-calendar', label:"Date field" },
		{ type:'attach', icon:'knk-attachment', label:"Documents field" },
	];
	
	const [sortable,setSortable] = useState([
		{id:1},
		{id:2},
		{id:3},
		{id:4},
		{id:5},
	]);

	const moveCard = useCallback((dragIndex, hoverIndex) => {
		setSortable(sortable=>{
			const dragItem = sortable[dragIndex];
			const arr = sortable.slice(0);
			arr.splice(dragIndex,1);
			arr.splice(hoverIndex,0,dragItem);
			return arr;
		})
	}, [sortable]);

	return (
		<DndProvider backend={HTML5Backend} options={{enableMouseEvents:true, enableTouchEvents:false}}>
			<div className="gui_flexbox gui_flex_col">
				Block builder
				<div className="gui_flexbox">
					<div>
						<h3>Elements</h3>
						
						{/* <div>
							{sortable.map((item,index) => (
								<SortCard key={item.id} item={item} index={index} moveCard={moveCard} />
							))}
						</div> */}

						<div>
							<ButtonBlock />
							<TextBlock />
							<ContainerBlock />
						</div>
						<h3>Structure</h3>

						<LayoutTree level={1} layout={state.layout} dispatch={dispatch} selected_item={state.selected_item} />

					</div>
					<div>
						<h3>Main</h3>
						<div style={{display:"flex",height:"500px",width:"700px",justifyContent:"center",alignItems:"center",border:"1px solid black"}}>
							{state.layout.map(element=>(
								<DropZone
									element={element}
									dispatch={dispatch}
									highlight={state.highlight}
									layout={element.items}
									level={1}
								/>

							))}
							{/* <DropZone element={{id:'main'}} dispatch={dispatch} layout={state.layout} level={1} /> */}
						</div>


					</div>
				</div>
			</div>
		</DndProvider>
	)
}

export default BlockBuilder;